export default {"src":"/_next/static/media/SleepDisorders.ff3955e1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};